import scss from "./TotalPoints.module.scss";
import { formatNumberWithCommas } from "../utils/utils";

export const TotalPoints = ({ score }) => {
  const cityRank = score.rankings.city.rank;
  const globalRank = score.rankings.global.rank;

  return (
    <section className={scss.scoreBox}>
      <div className={scss.totalPoints}>
        <label>PTS</label>{" "}
        <span>{formatNumberWithCommas(score.totalPoints)}</span>
      </div>
      <hr />
      <div className={scss.ranking}>
        <label>RANK</label>
        <label>CITY</label>
        <div>
          <p> {cityRank}</p>
          <p>#</p>
        </div>
      </div>
      <div className={scss.ranking}>
        <label>&emsp;&emsp;&nbsp;</label>
        <label>GLOBAL</label>
        <div>
          <p> {globalRank}</p>
          <p>#</p>
        </div>
      </div>
    </section>
  );
};
